import React from 'react';

import block from 'bem-cn-lite';

class Attachment extends React.Component {
    render() {
        const b = block('Attachment');
        const { name, date, user } = this.props
        return (
            <div className={b()}>
                <div className={b('preview')}>
                    <div className={b('preview-placeholder')}></div>
                </div>
                <div className={b('name')}>{name}</div>
                <div className={b('date')}>{date}</div>
                <div className={b('user')}>{user}</div>
            </div> 
        )
    }
}

export default Attachment